import { UserListDto } from "@shared/service-proxies/service-proxies";

export class ApproverDetail {
    user: UserListDto;
    WindowNum: number;
    WindowEnum: number;
    // constructor(user: UserListDto, WindowNum: number, WindowEnum: number) {
    //     this.user = user;
    //     this.WindowNum = WindowNum;
    //     this.WindowEnum=WindowEnum;
    // }
}